<header class="nav-container">
  <mat-toolbar class="navbar nav-responsive" style="background-color: white;">
    <div class="logo" routerLink="/dashboard">
      <a ><img src="../../../assets/images/umlaut_logo_login.svg" alt="umlaut_logo"></a>
      <span class="menu-toggle">
          <i class="material-icons">reorder</i>
      </span>
    </div>
    <ul class="nav">
      <li>
        <span class="nav-title">
            Route Planner
        </span>
      </li>
    </ul>
  </mat-toolbar> 
</header>